import PrivacyTipOutlined from "@mui/icons-material/PrivacyTipOutlined";
import { Box, Link, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

import {
  SCOUT_INFO_PANEL_CONTENT_BY_TAB,
  SCOUT_SUPPORT_ARTICLE,
  type ScoutInfoPanelItem,
  type ScoutInfoPanelTab,
} from "./scoutInfoPanelContent";

export function ScoutInfoPanelContentBody({
  tab,
  scrollable = true,
}: {
  tab: ScoutInfoPanelTab;
  /** When false, content flows in a parent scroll surface (e.g. side panel). */
  scrollable?: boolean;
}) {
  const content = SCOUT_INFO_PANEL_CONTENT_BY_TAB[tab];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        ...(scrollable ? { flex: 1, overflow: "auto", minHeight: 0 } : { flex: "0 0 auto" }),
        p: isMobile ? 3 : 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {content.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          {content.subtitle}
        </Typography>

        <Stack spacing={3} pt={3}>
          {content.items.map((item) => (
            <ScoutInfoPanelListItem key={item.title} item={item} />
          ))}
        </Stack>
      </Stack>

      {tab === "privacy" ? (
        <Link
          href={SCOUT_SUPPORT_ARTICLE}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            fontWeight: 400,
            fontSize: 14,
            gap: 1,
            mt: 3,
          }}
        >
          <PrivacyTipOutlined sx={{ fontSize: 20 }} />
          Learn more about our Knowledge Base
        </Link>
      ) : null}
    </Box>
  );
}

function ScoutInfoPanelListItem({ item }: { item: ScoutInfoPanelItem }) {
  return (
    <Stack direction="column" spacing={2} alignItems="flex-start">
      <Box
        component="img"
        src={item.iconSrc}
        alt={item.title}
        sx={{
          width: 56,
          height: 56,
        }}
      />
      <Stack spacing={0.5} sx={{ minWidth: 0 }}>
        <Typography variant="subtitle1">{item.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {item.description}
        </Typography>
      </Stack>
    </Stack>
  );
}
